import SettingTypes from '@/utils/setting-types'
import { platformType } from '@/utils/decor-types'

export default {
  name: 'activities',
  label: {
    title: '活动模块',
    icon: require('@/assets/icon-component-label_Activities.svg'),
    limit: -1,
    show: () => Number(platformType) === 1
  },
  sort: 105,
  data: {
    activities: []
  },
  settings: {
    activities: {
      type: SettingTypes.custom,
      component_name: 'ActivitiesSelector'
    }
  }
}
